import { keys as parentKeys } from '@copro/api';

const all = [...parentKeys.all, 'search'] as const;

export const keys = {
  all,
  query: (spaceId: string, searchTerm: string) => [...all, 'query', spaceId, searchTerm] as const,
};

